var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        width: "400px",
        "label-width": "130px",
        "append-to-body": false,
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [_vm._v("选择连接仓库")]),
      _vm.typeCode === "channel" || _vm.typeCode === "interline-virtual"
        ? _c(
            "el-form-item",
            { attrs: { label: "数量虚仓" } },
            [
              _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.qtyDataList.filter(function (e) {
                    return e.typeCode == "qty-virtual"
                  }),
                  "item-label": "name",
                  "item-value": "id",
                  multiple: "",
                },
                model: {
                  value: _vm.form.qtyVirtualIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "qtyVirtualIds", $$v)
                  },
                  expression: "form.qtyVirtualIds",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.typeCode === "channel"
        ? _c(
            "el-form-item",
            { attrs: { label: "比例虚仓" } },
            [
              _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.ratioDataList.filter(function (e) {
                    return e.typeCode == "ratio-virtual"
                  }),
                  "item-label": "name",
                  "item-value": "id",
                  multiple: "",
                },
                model: {
                  value: _vm.form.ratioVirtualIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "ratioVirtualIds", $$v)
                  },
                  expression: "form.ratioVirtualIds",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.typeCode === "qty-virtual" || _vm.typeCode === "ratio-virtual"
        ? _c(
            "el-form-item",
            { attrs: { label: "实仓", prop: "ids" } },
            [
              _c(
                "el-select",
                {
                  attrs: { multiple: "", "multiple-limit": 1, clearable: "" },
                  on: { change: _vm.handleChangeLogic },
                  model: {
                    value: _vm.form.ids,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "ids", $$v)
                    },
                    expression: "form.ids",
                  },
                },
                [
                  _vm._l(_vm.list, function (item) {
                    return [
                      _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.typeCode === "interline-virtual"
        ? _c(
            "el-form-item",
            { attrs: { label: "实仓" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.form.realId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "realId", $$v)
                    },
                    expression: "form.realId",
                  },
                },
                _vm._l(_vm.realDataList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.typeCode === "real"
        ? _c(
            "el-form-item",
            { attrs: { label: "逻辑仓" } },
            [
              _c(
                "el-select",
                {
                  attrs: { multiple: "", clearable: "" },
                  model: {
                    value: _vm.form.ids,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "ids", $$v)
                    },
                    expression: "form.ids",
                  },
                },
                [
                  _vm._l(_vm.list, function (item) {
                    return [
                      _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }